import { DrmProvider } from "@core-services/data-types"
import { z } from "zod"

const optionalUrl = z.union([z.literal(""), z.string().trim().url()])

export const UpsertDrm = z.object({
  organizationPublicId: z.string(),
  provider: z.nativeEnum(DrmProvider),
  token: z.string().max(2048),
  cpixUrl: z.string().url().max(500),
  widevineLicenseUrl: optionalUrl,
  playreadyLicenseUrl: optionalUrl,
  fairplayLicenseUrl: optionalUrl,
  fairplayCertificate: z.string().max(2048).optional(),
})

export type UpsertDrm = z.infer<typeof UpsertDrm>
